import styled from 'styled-components'

interface ICheckboxProps  {
    disabled?: boolean,
}

export const CheckboxInput = styled.input<ICheckboxProps>`
    opacity: ${ ({ disabled }) => disabled ? 0.6 : 1 } !important;
`